import { CATEGORY, COLOR, COLUMN, COMPLIANCE, FORMATTING, JARGON, LAYOUT } from "../../modules/constants"
import { addPaddingRightToLastCell, calcStats, getCell, getCellWithTooltip, headCell, setStats } from "../../modules/table.funcs"
import { formatFloat } from "../../modules/utilities"
import { initStats2 } from "../../components/layout/InitStats"
import { getGovObj, getGovPercentages } from "../../pages/companiesHouse/pageFunctions/complianceFunctions"

const { border1, integer, left, percent, string } = FORMATTING
const borderLeft = border1
const stats2 = {}

export const createGovernanceHeadersData = props => {
    // console.log('createGovernanceHeadersData props:', props)
    const { portrait, showLogos, the350club } = props

    const compliantWidth = "8%"
    const ageWidth = "8%"
    const femaleWidth = "8%"
    const execWidth = "8%"
    const noEmDirsWidth = "8%"

    const ageAvg = headCell({
        id: COLUMN.AGE_AVG,
        width: ageWidth,
    })

    const ageSd = headCell({
        id: COLUMN.AGE_SD,
        width: ageWidth,
    })

    const pcntFemale = headCell({
        id: COLUMN.PCNT_FEMALE,
        width: femaleWidth,
    })

    const company = headCell({
        align: left,
        colSpan: 2,
        id: COLUMN.COMPANY,
        label: "Company",
        tooltipTitle: "",
    })

    const compliant = headCell({
        id: COLUMN.COMPLIANT,
        width: compliantWidth,
    })

    const logo = headCell({
        align: left,
        id: COLUMN.LOGO,
        width: LAYOUT.LOGO_WIDTH,
    })

    const nonExecs9 = headCell({
        id: COLUMN.INDEP_NON_EXEC_9,
        width: execWidth,
    })

    const seniorFemale = headCell({
        id: COLUMN.SENIOR_FEMALE,
        width: femaleWidth,
    })

    const pcntNonExecs = headCell({
        borderLeft,
        id: COLUMN.PCNT_INDEP_NON_EXECS,
        width: execWidth,
    })

    const noEmDirs = headCell({
        id: COLUMN.EM_DIRs,
        width: noEmDirsWidth,
    })

    const nonBrits = headCell({
        borderLeft,
        id: COLUMN.NON_BRIT,
        width: execWidth,
    })

    const starHead = headCell({
        align: left,
        id: COLUMN.STAR,
        width: LAYOUT.STAR_WIDTH,
    })

    let headCells = portrait
        ? [starHead, company, compliant]
        : [starHead, company, compliant, pcntNonExecs, nonExecs9, pcntFemale, seniorFemale, noEmDirs, nonBrits, ageAvg, ageSd]

    if (showLogos)
        headCells.splice(1, 0, logo) // insert logo header

    if (the350club)
        headCells.shift() // Remove starHead

    addPaddingRightToLastCell(headCells)
    // console.log('headCells:', headCells)
    return headCells
}

export const createGovernanceFooterData = props => {
    // console.log('createLseCompaniesFooterwData props:', props)
    const { portrait, showLogos, the350club } = props
    let column = null
    const tooltip = ""

    for (const property in stats2)
        calcStats(stats2[property])

    column = COLUMN.AGE_AVG
    const ageAvg = {
        total: getCell({ column, tooltip }),
        mean: getCell({ column, tooltip })
    }

    column = COLUMN.AGE_SD
    const ageSd = {
        total: getCell({ column, tooltip }),
        mean: getCell({ column, tooltip })
    }

    column = COLUMN.COMPLIANT
    let tooltipTotal = `Number of companies that comply with all ${COMPLIANCE.TARGETS} targets`
    let tooltipMean = `Proportion of companies that comply with all ${COMPLIANCE.TARGETS} targets`

    const compliant = {
        total: getCell({ column, type: integer, tooltip: tooltipTotal, value: stats2[column].total }),
        mean: getCell({ column, suffix: "%", type: percent, tooltip: tooltipMean, value: stats2[column].mean })
    }

    tooltipTotal = `Number of companies that comply with target`
    tooltipMean = `Proportion of companies that comply with target`

    column = COLUMN.INDEP_NON_EXEC_9
    const nonExecs9 = {
        total: getCell({ column, tooltip: tooltipTotal, type: integer, value: stats2[column].total }),
        mean: getCell({ column, suffix: "%", tooltip: tooltipMean, type: percent, value: stats2[column].mean })
    }

    column = COLUMN.PCNT_INDEP_NON_EXECS
    const pcntNonExecs = {
        total: getCell({ borderLeft, tooltip: tooltipTotal, column, type: integer, value: stats2[column].total }),
        mean: getCell({ borderLeft, column, suffix: "%", tooltip: tooltipMean, type: percent, value: stats2[column].mean })
    }

    column = COLUMN.SENIOR_FEMALE
    const seniorFemale = {
        total: getCell({ column, tooltip: tooltipTotal, type: integer, value: stats2[column].total }),
        mean: getCell({ column, suffix: "%", tooltip: tooltipMean, type: percent, value: stats2[column].mean })
    }

    column = COLUMN.PCNT_FEMALE
    const pcntFemale = {
        total: getCell({ column, tooltip: tooltipTotal, type: integer, value: stats2[column].total }),
        mean: getCell({ column, suffix: "%", tooltip: tooltipMean, type: percent, value: stats2[column].mean }),
    }

    column = COLUMN.EM_DIRs
    const emDirs = {
        total: getCell({ column, tooltip: tooltipTotal, type: integer, value: stats2[column].total }),
        mean: getCell({ column, suffix: "%", tooltip: tooltipMean, type: percent, value: stats2[column].mean })
    }

    column = COLUMN.NON_BRIT
    const nonBrits = {
        total: getCell({ borderLeft, column, tooltip }),
        mean: getCell({ borderLeft, column, tooltip })
    }

    column = COLUMN.COMPANY
    const suffix = ` ${stats2[column].total === 1 ? JARGON.COMPANY : JARGON.COMPANIES}`
    const company = {
        total: getCell({ align: left, column, suffix, tooltip, type: integer, value: stats2[column].total }),
        mean: getCell({ column })
    }

    column = COLUMN.STAR
    const starFoot = {
        total: getCell({ column }),
        mean: getCell({ column })
    }

    column = COLUMN.LEGEND
    const legend = {
        total: getCell({ column, label: "Compliant:", tooltip }),
        mean: getCell({ column, label: "% Compliant:", tooltip }),
    }

    const footCells = {
        totals: portrait
            ? [starFoot.total, company.total, legend.total, compliant.total]
            : [starFoot.total, company.total, legend.total, compliant.total, pcntNonExecs.total, nonExecs9.total, pcntFemale.total, seniorFemale.total, emDirs.total, nonBrits.total, ageAvg.total, ageSd.total],
        means: portrait
            ? [starFoot.mean, company.mean, legend.mean, compliant.mean]
            : [starFoot.mean, company.mean, legend.mean, compliant.mean, pcntNonExecs.mean, nonExecs9.mean, pcntFemale.mean, seniorFemale.mean, emDirs.mean, nonBrits.mean, ageAvg.mean, ageSd.mean]
    }

    if (showLogos) {
        const logoFoot = headCell({ id: COLUMN.LOGO, align: left })

        footCells.totals.splice(1, 0, logoFoot) // insert logo footer
        footCells.means.splice(1, 0, logoFoot) // insert logo footer
    }

    if (the350club) {
        footCells.totals.shift() // Remove starFoot
        footCells.means.shift()
    }

    addPaddingRightToLastCell(footCells.totals)
    addPaddingRightToLastCell(footCells.means)
    // console.log('footCells:', footCells)
    return footCells
}

//#region Rows
export const createGovernanceRowData = props => {
    // console.log('createGovernanceRowData props:', props)
    const { items, stats } = props
    let rows = []
    const tooltipTitle = "" // JARGON.MORE_INFO

    initStats2(stats2)

    items.forEach(item => {
        rows.push(createGovernanceRow({ ...props, item, tooltipTitle }))
        ++stats.numRows
    })
    // console.log('rows:', rows)
    return rows
}

const createGovernanceRow = ({ item, portrait, showLogos }) => {
    const { governance } = item
    const pcnt = getGovPercentages(governance)
    const govObj = getGovObj(item)

    const cellSpec = {
        [COLUMN.AGE_AVG]: {
            sortValue: typeof governance.age?.avg === "number" ? governance.age?.avg : 0,
            value: formatFloat(governance.age?.avg, 1),
        },
        [COLUMN.COMPANY]: {
            value: 1,
        },
        [COLUMN.COMPLIANT]: {
            ...govObj[COLUMN.COMPLIANT],
        },
        [COLUMN.NAME]: {
            align: left,
            colSpan: 2,
            type: string,
            value: item.names[0],
        },
        [COLUMN.AGE_SD]: {
            sortValue: typeof governance.age?.sd === "number" ? governance.age?.sd : 0,
            value: formatFloat(governance.age?.sd, 1),
        },
        [COLUMN.PCNT_INDEP_NON_EXECS]: {
            color: pcnt.nonExecs < COMPLIANCE.PCNT.NON_EXECS ? COLOR.WARN : COLOR.GOOD,
            sortValue: pcnt.nonExecs,
            type: percent,
            value: formatFloat(pcnt.nonExecs, 1),
            borderLeft,
        },
        [COLUMN.PCNT_FEMALE]: {
            ...govObj[COLUMN.PCNT_FEMALE],
            type: percent,
        },
        [COLUMN.SENIOR_FEMALE]: {
            ...govObj[COLUMN.SENIOR_FEMALE],
        },
        [COLUMN.EM_DIRs]: {
            ...govObj[COLUMN.EM_DIRs],
            color: governance.ethnic?.numDirs < 1 ? COLOR.WARN : COLOR.GOOD,
        },
        [COLUMN.NON_BRIT]: {
            value: governance.nonBrit,
            borderLeft,
        },
        [COLUMN.INDEP_NON_EXEC_9]: {
            color: governance.ninePlus > 0 ? COLOR.WARN : COLOR.GOOD,
            value: governance.ninePlus, // Non-Execs > 9 years tenure
        },
    }

    // NB: 'setStats()' accepts both a number or bool for its 1st parameter
    // since the unary '+' operator converts boolean into a number
    //#region Compliance
    setStats(cellSpec[COLUMN.COMPANY].value, stats2[COLUMN.COMPANY], true)
    setStats(cellSpec[COLUMN.COMPLIANT].sortValue === COMPLIANCE.TARGETS, stats2[COLUMN.COMPLIANT], true)
    setStats(cellSpec[COLUMN.PCNT_INDEP_NON_EXECS].sortValue >= COMPLIANCE.PCNT.NON_EXECS, stats2[COLUMN.PCNT_INDEP_NON_EXECS], true)
    setStats(cellSpec[COLUMN.INDEP_NON_EXEC_9].value == 0, stats2[COLUMN.INDEP_NON_EXEC_9], true)
    setStats(cellSpec[COLUMN.PCNT_FEMALE].sortValue >= COMPLIANCE.PCNT.FEMALE, stats2[COLUMN.PCNT_FEMALE], true)
    setStats(cellSpec[COLUMN.SENIOR_FEMALE].value > 0, stats2[COLUMN.SENIOR_FEMALE], true)
    setStats(governance.ethnic.numDirs > 0, stats2[COLUMN.EM_DIRs], typeof governance.ethnic.numDirs == "number")
    //#endregion Compliance

    setStats(cellSpec[COLUMN.NON_BRIT].value, stats2[COLUMN.NON_BRIT], true)
    setStats(cellSpec[COLUMN.AGE_AVG].sortValue, stats2[COLUMN.AGE_AVG], true)
    setStats(cellSpec[COLUMN.AGE_SD].sortValue, stats2[COLUMN.AGE_SD], true)

    const ageAvg = getCellWithTooltip(cellSpec[COLUMN.AGE_AVG])
    const ageSd = getCellWithTooltip(cellSpec[COLUMN.AGE_SD])
    const compliant = getCellWithTooltip(cellSpec[COLUMN.COMPLIANT])
    const name = getCellWithTooltip(cellSpec[COLUMN.NAME])
    const seniorFemale = getCellWithTooltip(cellSpec[COLUMN.SENIOR_FEMALE])
    const pcntFemale = getCellWithTooltip(cellSpec[COLUMN.PCNT_FEMALE])
    const pcntNonExecs = getCellWithTooltip(cellSpec[COLUMN.PCNT_INDEP_NON_EXECS])
    const ninePlus = getCellWithTooltip(cellSpec[COLUMN.INDEP_NON_EXEC_9])
    const nonBrits = getCellWithTooltip(cellSpec[COLUMN.NON_BRIT])
    const emDirs = getCellWithTooltip(cellSpec[COLUMN.EM_DIRs])

    const logo = item.logo
        ? item.logo
        : "no logo"

    const cellWithTooltips = portrait
        ? [name, compliant] // portrait
        : [name, compliant, pcntNonExecs, ninePlus, pcntFemale, seniorFemale, emDirs, nonBrits, ageAvg, ageSd]

    addPaddingRightToLastCell(cellWithTooltips)

    return {
        _id: item.ids[0],
        category: CATEGORY.COMPANY,
        cellWithTooltips,
        iconColor: COLOR.GOOD,
        ids: item.ids,
        index: item.index,
        isFavourite: item.isFavourite,
        link: `/company/${item.ids[0]}`,
        logo: showLogos ? logo : null, // insert logo
        title: item.companyName,
    }
}
//#endregion Rows

